import FormProvider from "./FormProvider";
import FormLayout from "./FormLayout";
import { Suspense } from "react";
import { Skeleton } from "@/components/ui/skeleton";

const LoadingFallback = () => (
  <div className="space-y-4">
    <Skeleton className="h-8 w-full" />
    <div className="grid grid-cols-7 gap-2">
      {Array(7)
        .fill(0)
        .map((_, i) => (
          <Skeleton key={i} className="h-20 w-full" />
        ))}
    </div>
    <Skeleton className="h-64 w-full" />
    <div className="flex justify-between">
      <Skeleton className="h-10 w-20" />
      <Skeleton className="h-10 w-20" />
    </div>
  </div>
);

const MultiStepListingForm = () => {
  return (
    <FormProvider>
      <Suspense fallback={<LoadingFallback />}>
        <FormLayout />
      </Suspense>
    </FormProvider>
  );
};

export default MultiStepListingForm;
